module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "part01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v("PART I"), _c('br'), _c('em', [_vm._v("The View from London")])]), _vm._v(" "), _c('p', {
    staticClass: "centerp"
  }, [_vm._v("For if America should grow into a separate empire it must of course cause . . . a revolution in the political system of the world.")]), _vm._v(" "), _c('p', {
    staticClass: "centerp1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PEECH OF")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORTH")]), _vm._v(", November 20, 1778"), _c('a', {
    attrs: {
      "id": "page_16"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a2b3892","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part01.vue
// module id = 84
// module chunks = 0